import { CorporateAdminStatus } from './../../enums/corporate-admin-status.enum';
import { CorporateAdminDto } from './../../models/admin/corporate-admin.dto';
export const corporateAdminsMock: CorporateAdminDto[] = [
  {
    id: '7b6d4c2a-3a1f-4b6f-8b7c-1b2c3d4e5f60',
    corporationId: '0c2f6a2b-9d5e-4d1f-a7d2-3f4e5a6b7c8d',
    locationId: '1a2b3c4d-5e6f-47a8-9b0c-1d2e3f4a5b6c',
    positionId: '2b3c4d5e-6f70-48a9-8b1c-2d3e4f5a6b7c',
    roleId: '3c4d5e6f-7081-49ba-9c2d-3e4f5a6b7c8d',
    userId: '4d5e6f70-8192-4acb-8d3e-4f5a6b7c8d9e',
    firstName: 'Andrea',
    lastName: 'García',
    email: 'andrea.garcia@corp.com',
    contactNumber: '(510) 456-7890',
    hireDate: '2023-04-15',
    isRehireEligible: true,
    status: CorporateAdminStatus.Active,
    isActive: true,
    createdAt: '2024-01-10T14:30:00Z',
    updatedAt: '2025-02-02T09:15:00Z'
  },
  {
    id: '9f1e2d3c-4b5a-4687-9c0d-1e2f3a4b5c6d',
    corporationId: '0c2f6a2b-9d5e-4d1f-a7d2-3f4e5a6b7c8d',
    roleId: '6a7b8c9d-0e1f-4a2b-8c3d-4e5f6a7b8c9d',
    firstName: 'Luis',
    lastName: 'Ramos',
    email: 'luis.ramos@corp2.com',
    contactNumber: '(510) 456-7891',
    hireDate: '2022-09-01',
    terminationDate: '2024-12-20',
    terminationReason: 'Resignation',
    isRehireEligible: false,
    status: CorporateAdminStatus.Inactive,
    isActive: false,
    createdAt: '2022-09-01T13:00:00Z',
    updatedAt: '2025-02-02T09:15:00Z'
  }
];
